import React, { useState, useRef, useEffect } from "react";
import "./css/multi-select-dropdown.css";

const MultiSelectDropdown = ({
  label,
  options,
  required,
  setSelectedOptions,
  selectedOptions = [],
  handleSelect,
  isError,
  errorMessage,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
    setIsActive(true);
  };

  const handleSelectAll = () => {
    const newSelectedOptions =
      selectedOptions.length === options.length ? [] : options;
    setSelectedOptions(newSelectedOptions);
    if (handleSelect) {
        handleSelect([]);
      }
  };

  const handleClearAll = (e) => {
    e.stopPropagation();
    setSelectedOptions([]);
    if (handleSelect) {
        handleSelect([]);
      }
  };

  const handleRemove = (option) => {
    const newSelectedOptions = selectedOptions.filter(
      (item) => item !== option
    );
    setSelectedOptions(newSelectedOptions);
    if (handleSelect) {
        handleSelect(newSelectedOptions);
      }
  };

  useEffect(() => {
    if (selectedOptions.length === 0) {
      setIsActive(false);
    }
  }, [selectedOptions]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        if (selectedOptions.length === 0) setIsActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedOptions]);

  return (
    <div ref={dropdownRef} className={`pre-booking-multi-select-wrapper `}>
      <div
        className={`pre-booking-multi-select-input ${
          isError && "error-border"
        } ${isOpen ? "change-border-color-select" : ""}`}
        onClick={toggleDropdown}
      >
        {label && (
          <label
            className={`pre-booking-multi-select-label ${
              isOpen ? "change-label-color" : ""
            } ${isError ? "error-label" : ""}`}
          >
            {label} {required && <span className="required">*</span>}
          </label>
        )}
        <div
          className={`pre-booking-selected-container ${
            isActive ? "dropdown-active" : ""
          }`}
        >
          {Array.isArray(selectedOptions) && selectedOptions.length > 0 && (
            <div className="">
              {selectedOptions.map((option, index) => (
                <span key={index} className="pre-booking-selected-item">
                  {option}
                  <button
                    className="pre-booking-remove-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemove(option);
                    }}
                  >
                    ✕
                  </button>
                </span>
              ))}
            </div>
          ) 
          // : (
          //   <span
          //     className={`pre-booking-placeholder-text ${
          //       isActive ? "dropdown-active" : ""
          //     }`}
          //   >
          //     {label}...
          //   </span>
          // )
          }
        </div>

        {Array.isArray(selectedOptions) && selectedOptions.length > 0 && (
          <button
            className={`pre-booking-clear-btn ${
              isActive ? "dropdown-cancel-active" : ""
            }`}
            onClick={handleClearAll}
          >
            Clear All
          </button>
        )}

        <button className="pre-booking-toggle-btn">{isOpen ? "▲" : "▼"}</button>
      </div>
      {isError && <p className="pre-booking-error-message">{errorMessage}</p>}

      {isOpen && (
        <div
          className={`pre-booking-dropdown-list ${
            isActive ? "dropdown-active" : ""
          }`}
        >
          <div className="pre-booking-dropdown-item" onClick={handleSelectAll}>
            <input
              type="checkbox"
              checked={selectedOptions.length === options.length}
              readOnly
            />
            Select All
          </div>
          {options.map((option, index) => (
            <div
              key={index}
              className="pre-booking-dropdown-item"
              onClick={() => {
                const newSelectedOptions = selectedOptions.includes(option)
                  ? selectedOptions.filter((item) => item !== option)
                  : [...selectedOptions, option];
                setSelectedOptions(newSelectedOptions);
                if (handleSelect) {
                  handleSelect(newSelectedOptions);
                }
              }}
            >
              <input
                type="checkbox"
                checked={selectedOptions.includes(option)}
                readOnly
              />
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;


